/**
 * 地块信息路由
 */
const LandRouter = {
  path: 'land',
  name: 'Land',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Land/index')
}
export default LandRouter
